module.exports = __webpack_public_path__ + "static/BBC-9bf48099eacd362dc99eeb0a3715534f.png";